import React from "react";

import Banner from "../components/Banner";
import About from "../components/About";
import Requirements from "../components/Requirements";
import SignUp from "../components/SignUp";
import Foot from "../components/Foot";

const Home = () => {
  return (
    <>
      <Banner />
      <About />
      <Requirements />
      <SignUp />
      <Foot />
    </>
  );
};

export default Home;
